import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { ProductClientService } from './product-client.service';

import { Globals } from '../globals';

export interface LiftOrder {
  active: number;
  createdAt: any;
  updatedAt: any;

  date: string;
  number: string; //Revisar tipo dato
  quantity: number;
  pricePerUnit: number;
  
  basedOn: BasedOn;
  customerRef: any;
  prClientRef: any;
  quotRef: any;
  prVntaRef: any;
  addressId: string;

  productionOrderRef: any;
  status: number;
}

interface LiftOrderId extends LiftOrder {
  id: string;
}

export enum BasedOn {
  Undefined,
  PrVnta,
  PrClient,
  Quot
}

@Injectable()
export class LiftOrderService {

  liftOrderCollection: AngularFirestoreCollection<LiftOrder>;
  liftOrders: any;

  liftOrderDocument: AngularFirestoreDocument<LiftOrderId>;
  liftOrder: Observable<LiftOrderId>;

  collection: string;
  customerCollection: string;
  prClientCollection: string;
  quotCollection: string;
  prVntaCollection: string;
  productionOrderCollection: string;

  // NOTE: Change this any for LiftOrder Interface
  liftOrder$: Observable<any>;
  liftOrders$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private prClientService: ProductClientService,
    private router: Router
  ) {
    this.collection = Globals.LIFT_ORDER_COLLECTION;
    this.customerCollection = Globals.CUSTOMER_SUPPLIER_COLLECTION;
    this.prClientCollection = Globals.PRCLIENT_COLLECTION;
    this.quotCollection = Globals.QUOT_COLLECTION;
    this.prVntaCollection = Globals.PRVNTA_COLLECTION;
    this.productionOrderCollection = Globals.PRODUCTION_ORDER_COLLECTION;
  }

  /**
   * Get all liftOrders with references
   * @return {Observable} Arrays of liftOrders
   */
  getLiftOrders({fromDate = '', onEmpty = null} = {}) {
    let col;
    if(fromDate){
      col = this.afh.colWithIds$(this.collection, ref => ref.orderBy('date','desc').where('active', '==', true).where('date', '>=', fromDate) );
    }else{
      col = this.afh.colWithIds$(this.collection, ref => ref.orderBy('createdAt','desc').where('active', '==', true) );
    }
    return col.map(documents => {
      if(!documents.length && onEmpty) onEmpty();
      return documents.map(document => {
        let hasQuot = !!document.quotRef, hasPrVnta = !!document.prVntaRef, hasPrClient = !!document.prClientRef;
  
        const customerRef = this.afh.docWithIds$(`${document.customerRef.path}`);
        const prClientRef = hasPrClient ? this.prClientService.getPrClient(document.prClientRef.id) : customerRef;
        const quotRef = hasQuot ? this.afh.docWithIds$(`${document.quotRef.path}`) : customerRef;
        const prVntaRef = hasPrVnta ? this.afh.docWithIds$(`${document.prVntaRef.path}`) : customerRef;
        
        const productionOrderRef = document.status ? this.afh.docWithIds$(`${document.productionOrderRef.path}`) : undefined;
  
        if(!document.status)
        return Observable.combineLatest(
          customerRef,
          prClientRef,
          quotRef,
          prVntaRef,
          (customerData, prClientData, quotData, prVntaData) => ({
            customer: customerData,
            prClient: hasPrClient ? prClientData : undefined,
            quot: hasQuot ? quotData : undefined,
            prVnta: hasPrVnta ? prVntaData : undefined
          })
        ).map( data => ({ customerObj: data.customer, prClientObj: data.prClient, quotObj: data.quot, prVntaObj: data.prVnta, ...document }) );
          
        else
        return Observable.combineLatest(
          customerRef,
          prClientRef,
          quotRef,
          prVntaRef,
          productionOrderRef,
          (customerData, prClientData, quotData, prVntaData, productionOrderData) => ({
            customer: customerData,
            prClient: hasPrClient ? prClientData : undefined,
            quot: hasQuot ? quotData : undefined,
            prVnta: hasPrVnta ? prVntaData : undefined,
            productionOrder: productionOrderData
          })
        ).map( data => ({ customerObj: data.customer, prClientObj: data.prClient, quotObj: data.quot, prVntaObj: data.prVnta, productionOrderObj: data.productionOrder, ...document }) );
  
      });
    }).mergeMap(quotsDocuments => Observable.combineLatest(quotsDocuments));
  }

  /**
  * Get liftOrder data
  * @param {string} sid - The id of the liftOrder
  * @return {Observable} The LiftOrder Object
  */
  getLiftOrder(sid: string) {
    return this.liftOrder$ = this.afh.docWithIds$(this.collection + '/' + sid).map(document => {
      let hasQuot = !!document.quotRef, hasPrVnta = !!document.prVntaRef, hasPrClient = !!document.prClientRef;

      const customerRef = this.afh.docWithIds$(`${document.customerRef.path}`);
      const prClientRef = hasPrClient ? this.prClientService.getPrClient(document.prClientRef.id) : customerRef;
      const quotRef = hasQuot ? this.afh.docWithIds$(`${document.quotRef.path}`) : customerRef;
      const prVntaRef = hasPrVnta ? this.afh.docWithIds$(`${document.prVntaRef.path}`) : customerRef;
      
      const productionOrderRef = document.status ? this.afh.docWithIds$(`${document.productionOrderRef.path}`) : undefined;

      if(!document.status)
      return Observable.combineLatest(
        customerRef,
        prClientRef,
        quotRef,
        prVntaRef,
        (customerData, prClientData, quotData, prVntaData) => ({
          customer: customerData,
          prClient: hasPrClient ? prClientData : undefined,
          quot: hasQuot ? quotData : undefined,
          prVnta: hasPrVnta ? prVntaData : undefined
        })
      ).map( data => ({ customerObj: data.customer, prClientObj: data.prClient, quotObj: data.quot, prVntaObj: data.prVnta, ...document }) );
        
      else
      return Observable.combineLatest(
        customerRef,
        prClientRef,
        quotRef,
        prVntaRef,
        productionOrderRef,
        (customerData, prClientData, quotData, prVntaData, productionOrderData) => ({
          customer: customerData,
          prClient: hasPrClient ? prClientData : undefined,
          quot: hasQuot ? quotData : undefined,
          prVnta: hasPrVnta ? prVntaData : undefined,
          productionOrder: productionOrderData
        })
      ).map( data => ({ customerObj: data.customer, prClientObj: data.prClient, quotObj: data.quot, prVntaObj: data.prVnta,productionOrderObj: data.productionOrder, ...document }) );

    }).mergeMap(quotsDocuments => Observable.combineLatest(quotsDocuments));
  }

  /**
  * Create new liftOrder
  * @param {LiftOrder} liftOrder - The data of the liftOrder
  */
  addLiftOrder({quotRef, prClientRef, prVntaRef, ...liftOrder}) {
    liftOrder.customerRef = this.afh.doc(`${this.customerCollection}/${liftOrder.customerRef}`).ref;
    if(prClientRef) liftOrder.prClientRef = this.afh.doc(`${this.prClientCollection}/${prClientRef}`).ref;
    if(quotRef) liftOrder.quotRef = this.afh.doc(`${this.quotCollection}/${quotRef}`).ref;
    if(prVntaRef) liftOrder.prVntaRef = this.afh.doc(`${this.prVntaCollection}/${prVntaRef}`).ref;
    this.afh.add(`${this.collection}`, liftOrder);
  }

  /**
   * Update current liftOrder
   * @param {string} sid  - The id of the liftOrder
   * @param {LiftOrder} liftOrder - The data of the liftOrder
   */
  updateLiftOrder(sid: string, {quotRef, prClientRef, prVntaRef, ...liftOrder}) {
    liftOrder.customerRef = this.afh.doc(`${this.customerCollection}/${liftOrder.customerRef}`).ref;
    if(prClientRef) liftOrder.prClientRef = this.afh.doc(`${this.prClientCollection}/${prClientRef}`).ref;
    if(quotRef) liftOrder.quotRef = this.afh.doc(`${this.quotCollection}/${quotRef}`).ref;
    if(prVntaRef) liftOrder.prVntaRef = this.afh.doc(`${this.prVntaCollection}/${prVntaRef}`).ref;
    if(liftOrder.status) liftOrder.productionOrderRef = this.afh.doc(`${this.productionOrderCollection}/${liftOrder.productionOrderRef}`).ref;
    this.afh.update(`${this.collection}/${sid}`, liftOrder);
  }

  get afhService(){
    return this.afh;
  }

  /**
   * Delete current liftOrder
   * @param {string} sid - The id of the liftOrder
   */
  deleteLiftOrder(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  windowReplace(action: string, id?: string){
    switch(action){
      case 'add':
      case 'create':
        this.router.navigate([`/new_liftOrder/${id}`]);
        break;
      case 'edit':
      case 'update':
        this.router.navigate([`/edit_liftOrder/${id}`]);
        break;
      case 'view':
      case 'display':
        this.router.navigate([`/vw_liftOrder/${id}`]);
        break;
      case 'read':
        this.router.navigate([`/liftOrder`]);
        break;
      default:
        console.log('Not an action');
    }
  }
}
